import{defineMessages}from'react-intl';

export default defineMessages({

eventActionModalCancelllationConfirm:{
id:'i18n.PopoutModal.confirm.message',
defaultMessage:'Are you sure want to cancel Yes/No?'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9Qb3BvdXRNb2RhbC9Qb3BvdXRNb2RhbC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsImV2ZW50QWN0aW9uTW9kYWxDYW5jZWxsbGF0aW9uQ29uZmlybSIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7O0FBRTVCQyxxQ0FBc0M7QUFDcENDLEdBQUksa0NBRGdDO0FBRXBDQyxlQUFnQixxQ0FGb0IsQ0FGVixDQUFmLENBQWYiLCJmaWxlIjoiUG9wb3V0TW9kYWwubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcblxuICBldmVudEFjdGlvbk1vZGFsQ2FuY2VsbGxhdGlvbkNvbmZpcm06IHtcbiAgICBpZDogJ2kxOG4uUG9wb3V0TW9kYWwuY29uZmlybS5tZXNzYWdlJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FyZSB5b3Ugc3VyZSB3YW50IHRvIGNhbmNlbCBZZXMvTm8/JyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/pages/PopoutModal/PopoutModal.messages.js
// module id = 2180
// module chunks = 0